import * as Yup from 'yup';

export default Yup.object().shape({
  templateName: Yup.string().required('required'),
  participantsSource: Yup.string(),
  device: Yup.string().nullable(),
  operatingSystem: Yup.array().of(Yup.string()).when('device', (device) => {
    if (device !== null) {
      return Yup.array().of(Yup.string()).required(
        'Please select the operating systems that participants should use during the study.',
      ).min(1,
        'Please select the operating systems that participants should use during the study.');
    }
    return Yup.array().of(Yup.string());
  }).nullable(),
  questions: Yup.array().of(Yup.object().shape({
    question: Yup.string().required('required'),
    answers: Yup.array().of(Yup.object().shape({
      answer: Yup.string().required('required'),
    })).required('required'),
  })),
});
